import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import FFPaper from '../../shared/FFPaper';
import FFLinearProgress from '../../shared/FFLinearProgress';
import ToggleOnIcon from '@mui/icons-material/ToggleOnOutlined';
import BigLabel from '../../shared/BigLabel';
import BlueBox from '../../shared/BlueBox';
import TinyLabel from '../../shared/TinyLabel';
import MediumLabel from '../../shared/MediumLabel';
import { PercentageValues } from '../../../model/enrollment';


export interface EnabledDisabledProps {
    data?: PercentageValues;
}


export default function EnabledDisabledCard({ data }: EnabledDisabledProps) {

    const percentagesValue = data?.value.map(({ percentages }) => Number(percentages.replace('%', '')));
    const labelsValue = data?.value.map(({ groupName }) => groupName);

    return (

        <Grid item={true} xs={12} sx={{ height: '100%', flexGrow: 1 }}>
            <FFPaper
                elevation={3}
                sx={{
                    height: '100%',
                    pb: 2,
                    pt: 2
                }}
            >
                <Stack direction="row" sx={{ alignItems: 'center', width: '95%' }}>
                    <BlueBox sx={{
                        borderRadius: 2
                    }}>
                        <ToggleOnIcon fontSize="large" sx={{ backgroundColor: 'text.secondary', color: 'white', textAlign: 'center' }} />
                    </BlueBox>

                    <Stack sx={{ width: '100%', height: '100%' }}>

                        <Stack direction="row" sx={{
                            alignItems: 'center',
                            pb: 1,
                        }}>

                            <Stack
                                sx={{
                                    flex: '1 0 50%',
                                }}>
                                <BigLabel sx={{
                                    textAlign: 'left'
                                }}>
                                    {percentagesValue?.join('/')}
                                </BigLabel>

                                <FFLinearProgress big={false} progressValue={80} />
                            </Stack>

                            <Stack>
                                <TinyLabel>Updated 1 min ago</TinyLabel>

                                <MediumLabel>{labelsValue?.join('/')}</MediumLabel>

                            </Stack>

                        </Stack>

                    </Stack>

                </Stack>

            </FFPaper>
        </Grid>

    )

}
